import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { CustomerNotesService } from './customer-notes.service';
import { CustomerNotesSearchItem } from './customer-notes.model';
import { AppService } from '../../app.service';
import { MY_FORMATS } from '../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import moment from 'moment';
import { SelectionLists, Customer } from '../../entities';
import { NewCustomerNotesComponent } from './new-customer-notes/new-customer-notes.component';
import { ActivatedRoute } from '@angular/router';
import { LoadingService } from '../../shared/services/loading.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-customer-notes',
  templateUrl: './customer-notes.component.html',
  styleUrls: ['./customer-notes.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
        providers: [
          { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
          { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
          { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
        ],
})


export class CustomerNotesComponent implements OnInit {
  displayedColumns: string[] = [ 'AddressToCustomerName', 'CreatedDate', 'Note', 'CreatedUserName', 'Edit' ];
  dataSource =  new MatTableDataSource();

  selectedCustomer: Customer = new Customer();

  selectionLists: SelectionLists = new SelectionLists();

  StartDateControl = new FormControl(moment());
  EndDateControl = new FormControl(moment());

  searchItem: CustomerNotesSearchItem;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  ngOnInit() {
    this._loading.startLoading();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this._appService.setPageTitle('Customer Notes');
    this._customerNotesService.GetAllCustomerNotes().subscribe(r => {
      this.dataSource.data  = r;
    });

    this.searchItem = new CustomerNotesSearchItem( this._appService.defaultSearchStartDate,  this._appService.defaultSearchEndDate);
    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => {
      this._loading.finishedLoading();
      this.selectionLists.customerList = result;

      const customerId = +this._route.snapshot.paramMap.get('id');
      if (customerId !== undefined && customerId !== 0 ) {
        console.log(customerId);
        this.searchItem.CustomerId = customerId;
        const paramCustomer = result.filter(c => c.Id === customerId);
        this.selectedCustomer = paramCustomer.length > 0 ? paramCustomer[0] : new Customer();
        this.searchCustomerNote();
      }
    });
  }


  constructor(private _customerNotesService: CustomerNotesService,
    private _appService: AppService,
    private _dialog: MatDialog,
    private _route: ActivatedRoute,
    private _loading: LoadingService
    ) { }

  customerChanged(event) {
    this.selectedCustomer = event.value;
    if (! this.selectedCustomer ) {
      this.selectedCustomer = new Customer();
      this.searchItem.CustomerId = 0;
      this.searchCustomerNote();
      return;
    }
    this.searchItem.CustomerId = this.selectedCustomer.Id;
    this.searchCustomerNote();
  }


  searchCustomerNote() {
    this._loading.startLoading();
    this._customerNotesService.GetCustomerNotesBySearchItem(this.searchItem).subscribe(r => {
      this.dataSource.data = r;
      this._loading.finishedLoading();
    });
  }

  EndDateChanged(event) {
    this.searchItem.EndDate =  new Date(event);

  }
  StartDateChanged(event) {
    // console.log('b' + event);
    this.searchItem.StartDate =  new Date(event);

  }

  editCustomerNotes(element) {
    const dialogRef = this._dialog.open(NewCustomerNotesComponent, {
      panelClass: 'removeModalOverflow',
      data: {
       editCustomerNotes: element,
      }
    });

    dialogRef.afterClosed().subscribe(edited => {
      if (edited) {
       this.searchCustomerNote();
      }
    });
  }

  addNewCustomerNotes() {
    const dialogRef = this._dialog.open(NewCustomerNotesComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        selectedCustomer: this.selectedCustomer,
        listOfCustomers : this.selectionLists.customerList,
      }
    });

    dialogRef.afterClosed().subscribe(added => {
      if (added) {
        this.searchCustomerNote();
      }
    });
  }

}
